import {TasksContainer} from 'main/containers/tasks';
import {offboarding} from 'main/components/tasks';

const OffboardingTasksContainer = ({...rest}) => {
  return <TasksContainer config={offboarding} {...rest}/>;
};

export default OffboardingTasksContainer;
